import { useEffect, useState } from 'react';
import { connect } from 'react-redux'

//state
import {
    submitFormData,
    getApplicationStatus,
    updateCurrentProgress,
    loadingAction
} from '../../State/actions'

// utils
import * as constants from '../../Utils/constants';

// components
import Chapter from '../Wizard/Chapter'
import Answer from '../Form/Answer'
import ManualValidation from '../Wizard/ManualValidation'
import Error from '../Wizard/Error'
import QuestionHeader from '../Wizard/QuestionHeader'
import HeartLoader from '../../../../UI/HeartLoader';


const Form = (props) => {

    const [appId, setAppId] = useState('')
    const [formState, setFormState] = useState({ formId: '', Answers: [] })

    const [start, setStart] = useState(false)

    const chaptersToShow = 1;
    const [nextChapter, setNextChapter] = useState(chaptersToShow - 1);

    const [currentStatus, setCurrentStatus] = useState('')

    let increment = props.increment
    const url = props.url
    let error = currentStatus === "SubmitFailed" || currentStatus === "Rejected"

    //// get and add formId
    const formId = props.formId

    useEffect(() => {
        setFormState({ formId: formId, Answers: [] })
    }, [formId])

    // track and update progress
    useEffect(() => {
        let progress;

        if (formState.Answers.length > 0) {
            progress = formState.Answers.length + 1
            props.updateProgress(progress * increment)
        } else {
            progress = formState.Answers.length
            props.updateProgress(progress * increment)
        }
    }, [formState.Answers])

    // start application
    const onStart = (e) => {
        e.preventDefault()
        setStart(true)
        onNext()
        props.updateProgress(increment)
    }

    const onNext = () => {
        if (props.chapters) {
            if (nextChapter < props.chapters.length) {
                setNextChapter(nextChapter + 1)
            }
        }
    }

    // get index by id of answers, rmeove from that index
    const onReset = (id, currentChapterIndex, isLastQuestion) => {

        let formStateArr = formState.Answers
        let formStateObj = formState

        let index;

        let newProgress;

        if (id === 0 && currentChapterIndex === 0) {
            index = 0
            formStateArr.splice(index)

            setStart(!start)
            setNextChapter(index)

            props.updateProgress(0)

            // account component
        } else if (id === "account") {
            index = 2
            delete formStateObj.accountDetails

            newProgress = formState.Answers.length + 1
            props.updateProgress(newProgress * increment)

        }  else {
            index = formStateArr.findIndex(q => q.QuestionId === id)
            formStateArr.splice(index)

            setNextChapter(currentChapterIndex + 1)

            newProgress = formState.Answers.length + 1
            props.updateProgress(newProgress * increment)

            if (isLastQuestion) {
                index = 2
                delete formStateObj.accountDetails
            }
        }
    }

    // start submission process
    const onPreSignSubmit = (event) => {
        event.preventDefault()

        props.submitForm(formState)
        props.updateLoading(true)
    }

    // get appId for application submission
    useEffect(() => {
        if (!props.error) {
            if (props.appId && props.appId !== '') {
                setAppId(props.appId)
                setCurrentStatus('Submitted')
            }
        }
        if (props.error || props.hasErrored) {
            setCurrentStatus('SubmitFailed')
            props.updateLoading(false)
        }
    }, [props.appId, props.error, props.hasErrored])


    // get application status, act on current status and poll api until final status
    useEffect(() => {
        const status = props.status

        if (status === "Received" || status === "Pending") {
            setCurrentStatus(status)
        }

        if (status === "PendingManualValidation" || status === "Rejected") {
            props.updateLoading(false)
            setCurrentStatus(status)

        // redirect to bankid
        } else if (status === "WaitForSign") {
            window.location.href = `${url}?appId=${appId}`
        }
        
    }, [props.status]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (props.loading && appId !== '') {
                props.submitAppId({appId : appId})
            }
        }, 1000);
        return () => clearInterval(interval)
    }, [props.loading, appId])

    return (
        <div className="pension-wizard-block__container">

            {!props.loading && currentStatus === '' &&
                <form onSubmit={onPreSignSubmit}>

                    {!start && (
                        <>
                            <div className="pension-wizard-block__question">
                                <div className="pension-wizard-block__question__card">
                                    <QuestionHeader
                                        showCount={false}
                                        headline={constants.start.headline}
                                        text={constants.start.text}
                                    />
                                    <button
                                        type="button"
                                        disabled={props.chapters && props.chapters.length === 0 ? true : false}
                                        className={`button button--green ${props.chapters && props.chapters.length === 0 ? "disabled" : ""}`}
                                        onClick={onStart}>{constants.start.buttonText}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    {start && (
                        <section
                            className="pension-wizard-block__question answered"
                            tabIndex={-1}
                            onClick={() => {onReset(0, 0) }}
                        >
                            <div className="pension-wizard-block__question__card">
                                <div className="pension-wizard-block__question__card__question">
                                    <h2 className="pension-wizard-block__question__card__headline">{constants.start.buttonText}</h2>
                                    <Answer answer={constants.start.buttonText} />
                                </div>
                            </div>
                        </section>
                    )}

                    {props.chapters && props.chapters.length && props.chapters.slice(0, nextChapter).map((chapter, index) => (
                        <Chapter
                            key={index}
                            state={{ form: [formState, setFormState] }}
                            currentChapterIndex={index}
                            chapter={chapter}
                            title={() => props.setCurrentChapterTitle(chapter.title)}
                            questions={chapter.questions}
                            totalChapters={props.chapters.length}
                            total={props.questions.length}
                            handleNext={onNext}
                            handleReset={onReset}
                        />
                    ))}
                </form>
            }

            {props.loading && !props.questions && (<HeartLoader />)}

            {!props.loading && error && (<Error />)}

            {!props.loading && currentStatus === "PendingManualValidation" && (<ManualValidation />)}

        </div>

    )
}

// state

const mapStateToProps = (state) => {
    return {
        error: state.pensionWizard.error,
        hasErrored: state.pageHasErrored,
        status: state.pensionWizard.status,
        appId: state.pensionWizard.appId,
        formId: state.pensionWizard.formId,
        stop: state.pensionWizardFlow.stop,
        loading: state.pensionWizardFlow.loading,
        currentProgress: state.pensionWizardProgress.currentProgress,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitForm: (payload) => dispatch(submitFormData(payload)),
        submitAppId: (payload) => dispatch(getApplicationStatus(payload)),
        updateProgress: (payload) => dispatch(updateCurrentProgress(payload)),
        updateLoading: (payload) => dispatch(loadingAction(payload))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);

